import angular from "angular";

angular
	.module('app')
	.component('trApplicationReplyForm', {
		template: require('./tr-application-reply-form.html'),
        controller: ['$http', '$uibModal', controller],
        bindings: {
		    application: '<',
        }
    });

function controller($http, $uibModal) {

	let $ctrl = this;

	$ctrl.mileage = null;

	$ctrl.$onInit = function () {
        $ctrl.loading = false;
	};

	$ctrl.openChangeMileageModal = (carIndex, categoryKey, index) => {

	    let item = categoryKey ? $ctrl.application.app_cars[carIndex].app_categories[categoryKey][index] :
            $ctrl.application.app_cars[carIndex].app_others[index];

        $uibModal.open({
            component: 'trChangeMileageModal',
            size: 'sm',
            resolve: {
                item: function () {
                    return item;
                },
                applicationId: function () {
                    return $ctrl.application.id;
                }
            }
        }).result.then((res) => {
            window.Swal.fire({
                icon: 'success',
                title: 'Пробег изменен',
            });
            if (categoryKey) {
                $ctrl.application.app_cars[carIndex].app_categories[categoryKey][index].mileage = parseInt(res.mileage);
            } else {
                $ctrl.application.app_cars[carIndex].app_others[index].mileage = parseInt(res.mileage);
            }
        });
    }

    $ctrl.showAppCar = function (carIndex) {
        $ctrl.application.app_cars[carIndex].show = !$ctrl.application.app_cars[carIndex].show;
    }

    $ctrl.submit = function (button) {
        $ctrl.loading = true;
        $http.post('/tr/applications/' + $ctrl.application.id, {
            button: button,
            comment: $ctrl.comment,
        }).then(function (response){
            $ctrl.loading = false;
            window.Swal.fire({
                icon: 'success',
                title: response.data.message,
            }).then(function () {
                window.location = '/';
            })
        }, function (error) {
            $ctrl.loading = false;
            let checked = false;
            let message = '';
            angular.forEach(error.data.errors, function (value, key){
                if (!checked) {
                    message += value[0];
                    checked = true;
                }
            });
            if (message.length) {
                window.Swal.fire({
                    icon: 'error',
                    title: message,
                })
            } else {
                alert("Не известная ошибка обратитесь к администраций сайта");
            }
        })
    }

    $ctrl.destroy = () => {

        if (!confirm('Вы точно хотите удалить заявку?')) {
            $ctrl.loading = false;
            return;
        }

        const url = '/tr/applications/' + $ctrl.application.id + '/destroy';

        $ctrl.loading = true;

        $http
            .post(url)
            .then(
                () => {
                    $ctrl.loading = false;

                    window.Swal.fire({
                        icon: 'success',
                        title: 'Заявка удалена',
                    }).then(() => {
                        window.location = '/tr';
                    })
                },
                (error) => {
                    $ctrl.loading = false;

                    window.Swal.fire({
                        icon: 'error',
                        title: error.data.message,
                    });
                }
            );
    };

}
